import Button from "@mui/material/Button";
import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "./AppBar";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import { ACTIONS } from "../../../../../Providers/TemplateInstanceProvider";
import { Trans } from "react-i18next";
import TemplateContainer from "./TemplateContainer";
import ActionsContainer from "./ActionsContainer";
import ToolbarContainer from "./ToolbarContainer";
import ToolbarContent from "./ToolbarContent";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  toolbar: {
    backgroundColor: "white",
    flexGrow: 0,
    flexShrink: 0,
  },
  quantityContainer: {
    display: "flex",
    justifyContent: "center",
    padding: 0,
    margin: 0,
    listStyle: "none",
    marginBottom: theme.spacing(2),
  },
  quantityButton: {
    width: "64px",
    height: "64px",
  },
  inputQuantity: {
    width: "128px",
    height: "64px",
    border: "2px solid " + theme.palette.primary.main,
    boxSizing: "border-box",
    fontSize: "24px",
    textAlign: "center",
    lineHeight: "64px",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

export default ({ changeMenu }) => {
  const classes = useStyles();
  const [state, dispatch] = useTemplateInstance();
  const [currentYear, setCurrentYear] = useState(state.year);

  const decreaseYear = () => {
    const year = new Date().getFullYear();
    setCurrentYear((currentYear) => {
      let qty = parseInt(currentYear) - 1;
      if (qty < year) {
        qty = year;
      }
      return qty;
    });
  };

  const increaseYear = () => {
    setCurrentYear((currentYear) => {
      const year = new Date().getFullYear();
      if (!currentYear) {
        currentYear = year;
      }
      return parseInt(currentYear) + 1;
    });
  };

  const onChange = (e) => {
    setCurrentYear(e.target.value);
  };

  const onBlur = (e) => {
    if (
      isNaN(e.target.value) ||
      parseInt(currentYear) < new Date().getFullYear()
    ) {
      setCurrentYear(new Date().getFullYear());
    } else {
      setCurrentYear(e.target.value);
    }
  };

  const setYear = (currentYear) => {
    dispatch({
      type: ACTIONS.SET_YEAR,
      year: currentYear,
    });

    changeMenu("main");
  };

  return (
    <div className={classes.mainContainer}>
      <TemplateContainer year={currentYear} />

      <ToolbarContainer>
        <ToolbarContent>
          <ul className={classes.quantityContainer}>
            <li>
              <Button
                variant="contained"
                className={classes.quantityButton}
                color="primary"
                onClick={(e) => decreaseYear()}
              >
                -
              </Button>
            </li>
            <li>
              <input
                type="text"
                value={currentYear}
                className={classes.inputQuantity}
                onChange={onChange}
                onBlur={onBlur}
              />
            </li>
            <li>
              <Button
                variant="contained"
                className={classes.quantityButton}
                color="primary"
                onClick={(e) => increaseYear()}
              >
                +
              </Button>
            </li>
          </ul>
        </ToolbarContent>
        <ActionsContainer>
          <Button color="primary" onClick={() => changeMenu("main")}>
            <Trans>Cancel</Trans>
          </Button>
          <Button color="primary" onClick={() => setYear(currentYear)}>
            <Trans>Done</Trans>
          </Button>
        </ActionsContainer>
      </ToolbarContainer>
    </div>
  );
};
